module.exports = __webpack_public_path__ + "static/img/animals8.1fee8d46.png";